import React from 'react';
import { usePublicCategories, usePublicCategoryFilter } from '@/module/public/hooks';
import { usePublicSearchFilterQuery } from '@/module/public/hooks/usePublicSearchFilterQuery';
import { useAccordionStorage } from '@/module/public/stores/AccordionStore';
import { DropdownSchool } from '@/shared/quizList/DropdownSchool/DropdownSchool';
export const PublicDropdownSchool = ({
  forceTitlePillOnMobile = false
}: {
  forceTitlePillOnMobile?: boolean;
}) => {
  const {
    handleSelectedSchoolType,
    selectedSchoolTypeName
  } = usePublicCategoryFilter();
  const {
    schoolTypes
  } = usePublicCategories();
  const {
    clearSearchFilters
  } = usePublicSearchFilterQuery();
  const {
    resetAccordion
  } = useAccordionStorage();
  return <DropdownSchool variant="titlePill" forceTitlePillOnMobile={forceTitlePillOnMobile} selectedSchoolTypeName={selectedSchoolTypeName} schoolTypes={schoolTypes.map(s => ({
    name: s.name,
    value: s.name
  }))} onSelectedSchoolType={value => {
    void handleSelectedSchoolType(value);
    clearSearchFilters();
    resetAccordion();
  }} data-sentry-element="DropdownSchool" data-sentry-component="PublicDropdownSchool" data-sentry-source-file="PublicDropdownSchool.tsx" />;
};